import React from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';

import Breadcrumbs from 'Components/Utility/SEO/Breadcrumbs';


const BlogBreadcrumbs = ({ post, category, tag }) => {
  const crumbs = [];

  crumbs.push({
    label: 'Blog',
    link: '/blog',
  });

  if (category) {
    crumbs.push({
      label: startCase(category),
      link: `/blog/category/${category}`,
    });
  }

  if (tag) {
    crumbs.push({
      label: `Tagged: ${tag}`,
      link: `/blog?tag=${encodeURIComponent(tag)}`,
    });
  }

  if (post) {
    if (post.category) {
      crumbs.push({
        label: startCase(post.category),
        link: `/blog/category/${post.category.toLowerCase()}`,
      });
    }
    crumbs.push({
      label: post.title,
      link: `/blog/${post.slug}`,
    });
  }

  return <Breadcrumbs bannerPage crumbs={crumbs} appearsOn="blog" />;
};

export default BlogBreadcrumbs;

BlogBreadcrumbs.propTypes = {
  post: PropTypes.shape({}),
  category: PropTypes.string,
  tag: PropTypes.string,
};

BlogBreadcrumbs.defaultProps = {
  post: null,
  category: '',
  tag: '',
};
